import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { User } from '../types/auth';
import { Coworker } from '../types/coworkers.type';
import { Preferences } from '../types/preferences.type';

export const setUser = action(
  '[Auth] setUser',
  props<{ user: User | null } & SkipHistory>(),
);

export const setPreferences = action(
  '[Auth] setPreferences',
  props<{ preferences: Preferences } & SkipHistory>(),
);

export const setCoworkers = action(
  '[Auth] setCoworkers',
  props<{ coworkers: Coworker[] } & SkipHistory>(),
);
